// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.fd-label[data-v-5d2659fe] {\n  background-color: var(--5d2659fe-statusColor__bgColor);\n  border-radius: 30px;\n  font-size: 0.8rem;\n  line-height: 1.9rem;\n}\ndiv.fd-label:hover span[data-v-5d2659fe] {\n  text-decoration: underline;\n}\ndiv.fd-label span[data-v-5d2659fe] {\n  color: var(--5d2659fe-statusColor_textColor);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
